<div *ngIf="isAuthenticated">
  <p style="margin:auto;position:absolute;bottom:50%;left:0;right:0;color:white;"><font size="32"><b>SDPR</b></font><br><br>Logging out...</p>
</div>
<div *ngIf="!isAuthenticated">
  <p style="margin:auto;position:absolute;bottom:50%;left:0;right:0;color:white;"><font size="32"><b>SDPR</b></font><br><br>You have logged out. <br><br><br><i>Please close the window, <br>or hit refresh to log back in.</i></p>
</div>